import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './authConfig';

const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.initialize().then(() => {
  // Only call handleRedirectPromise in production (redirect flow).
  // On localhost we use popup flow so there is no redirect to handle.
  const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  return isLocalhost ? Promise.resolve(null) : msalInstance.handleRedirectPromise();
}).then((authResult) => {
  if (authResult && authResult.account) {
    msalInstance.setActiveAccount(authResult.account);
  }
}).catch((err) => {
  console.warn('[MSAL] Redirect error handled:', err);
}).finally(() => {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </React.StrictMode>
  );
});

reportWebVitals();